<script>
  import Icon from 'svelte-awesome';
  import { chevronDown } from 'svelte-awesome/icons';
</script>

<div class="main-header">
  <h1>
    <img src="images/logo.png" alt="logo" class="no-border">
    Adopciones Norte
  </h1>
  <a href="#main-content" class="arrow">
    <Icon data="{chevronDown}" scale="2" />
  </a>
</div>

<style>
  :global(body), :global(html) {
    margin: -54px 0 0 0;
    padding: 0;
    scroll-behavior: smooth;
  }
  img {
    display: block;
    margin: auto;
    margin-top: 2vh;
    height: 10vh;
  }

  @media screen and (orientation: portrait) and (max-width: 736px) {
    .main-header {
      background-size: auto auto auto 200%;
      background-image: url("../images/bg_banner_portrait.jpg") !important;
    }
  }
  
  .main-header {
    margin: 0;
    background-image: url("../images/bg_banner.jpg");
    background-size: auto, auto, 100% auto;
    background-position: center, center, top center;
    overflow: hidden;
    height: 900px;
    color: #ffffff;
    text-align: center;
    width: 100%;
  }

  .arrow {
      margin-top: 50vh;
      color: #ffffff;
      display: block;
    }

  a, a:visited {
    text-decoration: none;
    color: #ffffff;
    background-image: none;
  }
</style>